module.exports = __webpack_public_path__ + "img/icon-campaign.90ad30f8.svg";